<template>
  <DashBoardLayout :showNavbar=true :isSearch=false >
    <div class="w100 margin-bottom-primary">
      <div class="form-control-wrapper row align-items-center">
        <div class="bg_white col-xl-12 auto">
          <div class="admin-box-wrap">
            <div class="row">
              <div class="col-md-6 pl-4 pr-4">
                <div class="row head-form-section">
                  <div class="col-lg-10">
                    <h2>
                      My Profile (User ID :
                      <span>{{ customerDetail.customer_id }}</span
                      >)
                    </h2>
                  </div>
                </div>
                <div class="alert-success alert mt-2" v-if="profileSuccess">
                  Profile Updated Successfully
                </div>
                <div class="personal-institute">
                  <form
                    id="edit_profile"
                    class="w100 mt-2 form_wrapper_login"
                    autocomplete="off"
                  >
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      v-model="name"
                      class="profile w100 bod"
                    />
                    <label>Mobile No.</label>
                    <input
                      type="text"
                      name="mobile"
                      id="mobile"
                      disabled="true"
                      readonly="true"
                      v-model="mobile"
                      class="profile w100 bod"
                    />
                    <label class="not-required">Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      v-model="email"
                      class="profile w100 bod"
                    />
                    <label class="not-required">Gender</label>
                    <div class="w100 gender-field">
                      <input
                        type="radio"
                        name="gender"
                        id="male"
                        v-model="gender"
                        value="Male"
                        class="profile with-gap bod"
                      />
                      <label for="male">Male</label>
                      <input
                        type="radio"
                        name="gender"
                        id="female"
                        v-model="gender"
                        value="Female"
                        class="profile with-gap bod"
                      />
                      <label for="female">Female</label>
                    </div>
                  
              
                    <div class="col-lg-12 auto mt-3">
                      <input
                        type="button"
                        id="submitBtn"
                        class="submit-btn"
                        @click="updateProfile()"
                        value="Update"
                      />&nbsp;
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DashBoardLayout>
</template>

<script>
import axios from "axios";
import ApiList from "../ApiList";
import globalMixins from "../globalMixins";
import DashBoardLayout from "../../layouts/DashboardLayout.vue";
export default {
  name: "ProfileView",
  mixins: [ApiList, globalMixins],
  components: {
    DashBoardLayout,
  },
  // created(){
  //     this.$emit(`update:layout`,DashBoardLayout)
  // },
  data() {
    return {
      loading: false,
      newUrl: "",
      customerDetail: {},
      customer_id: -1,
      uriParam: "",
      paymentmsg: "",
      isMale: false,
      isFemale: false,
      name: "",
      mobile: "",
      email: "",
      gender: "",
      old_mobile: "",
      profileSuccess: false,
    };
  },
  mounted() {
    this.checkSession();
    this.loadData();
  },
  methods: {
    loadData() {
      this.customer_id = localStorage.getItem("customer_id");
      this.customerDetails();
    },
    customerDetails() {
      this.newUrl = this.apis.apiUrl + this.apis.customerListUrl;
      this.param = {
        params: {
          token: localStorage.token,
          customer_id: this.customer_id,
        },
      };
      axios.get(this.newUrl, this.param).then((response) => {
        // console.log(response)
        // this.orderList = []
        this.customerDetail = response.data[0];
        if (response.data[0].gender == "Male") {
          this.isMale = true;
          this.isFemale = false;
        } else if (response.data[0].gender == "Female") {
          this.isMale = false;
          this.isFemale = true;
        }
        this.name = response.data[0].name;
        this.mobile = response.data[0].mobile;
        this.email = response.data[0].email;
        this.gender = response.data[0].gender;
        this.old_mobile = response.data[0].mobile;
        // console.log("response : "+JSON.stringify(response.data[0]));
      });
    },
    updateProfile() {
      // console.log(this.name+" - "+this.gender+" - "+this.mobile+" - "+this.email)
      this.newUrl = this.apis.apiUrl + this.apis.updateCustomerProfileUrl;
      this.param = {
        params: {
          token: localStorage.token,
          name: this.name,
          gender: this.gender,
          email: this.email,
          mobile: this.old_mobile,
          old_mobile: this.old_mobile,
        },
      };
      axios.get(this.newUrl, this.param).then((response) => {
        console.log(response);
        this.profileSuccess = true;

        setTimeout(function () {
          this.profileSuccess = false;
          // console.log("aa");
        }, 2000);
      });
    },
  },
};
</script>

<style>
.bod {
  border: 1px solid #ccc !important;
}
</style>
